import { Component } from '@angular/core';
import { StatusButtons } from "../../../_shared/interfaces";
import { OrdersOverviewComponent } from "./orders-overview/orders-overview.component";
import { NgForOf } from "@angular/common";

@Component({
  selector: 'app-orders',
  standalone: true,
  imports: [
    OrdersOverviewComponent,
    NgForOf
  ],
  templateUrl: './orders.component.html',
  styleUrl: './orders.component.sass'
})
export class OrdersComponent {
  status: string = 'running';

  statusButtons: StatusButtons[] = [
    { state: 'all', display: 'Alle', label: 'alert-danger', icon: 'info-circle'},
    { state: 'open', display: 'Entwurf', label: 'label-light-blue', icon: 'info-circle'},
    { state: 'confirmed', display: 'Bestätigt', label: 'alert-info', icon: 'check-circle'},
    { state: 'running', display: 'In Arbeit', label: 'alert-warning', icon: 'exclamation-triangle'},
    { state: 'storno', display: 'Storniert', label: 'alert-warning', icon: 'exclamation-triangle'},
    { state: 'shipped', display: 'Abgeschickt', label: 'alert-info', icon: 'check-circle'},
    { state: 'invoiced', display: 'Berechnet', label: 'alert-green', icon: 'exclamation-circle'},
    { state: 'done', display: 'Erledigt', label: 'alert-success', icon: 'info-circle'}
  ];

  constructor() { }

  changeOverviewStatus(statusIndex: number){
    this.status = this.statusButtons[statusIndex].state;
  }
}
